export default function TutorDashboard({ fill, width, height }) {
  return (
    <svg
      width={width || "26"}
      height={height || "19"}
      viewBox="0 0 26 19"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.7 6.2C25.6 5.5 25.2 5 24.6 4.7L14.9 0.399998C13.9 -2.26498e-06 12.8 -0.100002 11.8 0.399998L1.2 4.6C0.5 4.9 0 5.6 0 6.4C0 7.2 0.4 7.8 1.1 8.1L3.6 9.1V13.6C3.6 14.6 4.2 15.4 5.1 15.7L11.9 18.4C12.4 18.6 12.9 18.7 13.4 18.7C14 18.7 14.6 18.6 15.1 18.3L21.1 15.5C21.9 15.1 22.4 14.3 22.4 13.4V9L23.5 8.5V10.7C23.5 11.3 24 11.7 24.5 11.7C25 11.7 25.5752 11.2 25.5752 10.7L25.7 6.2ZM20.4 13.4C20.4 13.5 20.4 13.5 20.3 13.6L14.3 16.4C13.8 16.6 13.2 16.6 12.7 16.4L5.9 13.7C5.8 13.7 5.8 13.6 5.8 13.5V10L11.9 12.5C12.4 12.7 12.9 12.8 13.4 12.8C14 12.8 14.5 12.7 15 12.5L20.5 10V13.4H20.4ZM14.1 10.5C13.6 10.7 13.1 10.7 12.6 10.5L2.5 6.4L12.6 2.3C13.1 2.1 13.6 2.1 14.1 2.3L23.3 6.4L14.1 10.5Z"
        fill={fill}
      />
    </svg>
  )
}
